export const selectAppointment = (state) => state.view_appointment;

export const selectMembersForAppointmentApply = (state) => {
  const appointment = selectAppointment(state);
  return appointment.applyAppointmentList;
};

export const selectPaginationInfo = (state) => {
  const appointment = selectAppointment(state);
  return appointment.paginationInfo;
};

export const selectBlockChiefPaginationInfo = (state) => {
  const appointment = selectAppointment(state);
  return appointment.blockChiefPaginationInfo;
};

export const selectLoader = (state) => {
  const appointment = selectAppointment(state);
  return appointment.isLoading;
};

export const selectAppointmentType = (state) => {
  const appointment = selectAppointment(state);
  return appointment.appointmentType;
};

export const selectAppointmentApplyFormValues = (state) => {
  const appointment = selectAppointment(state);
  return appointment.formValues;
};

export const selectSelectedPositionId = (state) => {
  const appointment = selectAppointment(state);
  return appointment.selectedPositionId;
};

export const selectMemberIdForAppointmentApply = (state) => {
  const appointment = selectAppointment(state);
  return appointment.selectedMemberId;
};

export const selectMemberForAppointmentApply = (state) => {
  const memberList = selectMembersForAppointmentApply(state);
  const selectedMemberId = selectMemberIdForAppointmentApply(state);
  return (
    memberList?.find(
      (member) =>
        (member?.memberId ?? member?.memberDetails?.memberId) ===
        selectedMemberId
    ) ?? {}
  );
};

export const selectSplitSearchResult = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.searchResult;
};

export const selectSplitLevel = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.splitLevel || "AREA";
};

export const selectParentStructure = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.parentStructure || "";
};

export const selectSelectedOS = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.organisationStructure || "";
};

export const selectParentStructureName = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.parentStrutureName || "";
};

export const selectStructureParent = (state) => {
  const appointment = selectAppointment(state);
  return appointment.split.parentStructureLevel || "";
};
